import type { SliderFieldConfig } from '../typings/shared';
import { createSliderField, type SliderField } from './sliderField';

/**
 * Initialize all slider fields on the page.
 * Configs are expected to be on window as: gps_field_slider_config_{formId}
 */
function initSliderFields() {
	// Find all slider config keys on window
	const configKeys = Object.keys(window).filter(
		(key): key is `gps_field_slider_config_${string}` =>
			key.startsWith('gps_field_slider_config_')
	);

	for (const key of configKeys) {
		const configs = window[key];

		if (!Array.isArray(configs)) {
			continue;
		}

		for (const config of configs as SliderFieldConfig[]) {
			initSliderField(config);
		}
	}
}

/**
 * Reset slider instances for a given form.
 * This is necessary for instances like AJAX validation errors where the form is re-rendered.
 * @param formId
 */
function clearFormHandlers(formId: string | number): void {
	if (!window.gpsSliderFields || !formId) {
		return;
	}

	const key = Number(formId);
	delete window.gpsSliderFields[key];
}

/**
 * Initialize a single slider field if not already initialized.
 * @param config
 */
function initSliderField(config: SliderFieldConfig): SliderField | null {
	const { formId, fieldId } = config;

	// Skip if already initialized
	if (window.gpsSliderFields?.[formId]?.[fieldId]) {
		return window.gpsSliderFields[formId][fieldId];
	}

	// Ensure nested structure exists
	if (!window.gpsSliderFields) {
		window.gpsSliderFields = {};
	}

	if (!window.gpsSliderFields[formId]) {
		window.gpsSliderFields[formId] = {};
	}

	// Create and store the instance
	const sliderField = createSliderField(config);
	if (sliderField) {
		window.gpsSliderFields[formId][fieldId] = sliderField;
	}

	return sliderField;
}

jQuery(document).on('gform_post_render', function (_event, formId) {
	clearFormHandlers(formId);
	initSliderFields();
});

document.addEventListener('gform/post_render', function (event) {
	const customEvent = event as CustomEvent<{ formId?: number }>;
	const formId = customEvent?.detail?.formId;

	if (!formId) {
		return;
	}

	clearFormHandlers(formId);
	initSliderFields();
});
